import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
import planConfig from '@/plugins/plan-config-lib'
import router from '@/router'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID
}
const FIREBASE_SERVER_TIMESTAMP = firebase.firestore.FieldValue.serverTimestamp()
const GAPI_CLIENTID = process.env.VUE_APP_GAPI_CLIENTID
const GAPI_APIKEY = process.env.VUE_APP_GAPI_APIKEY
const GAPI_SCOPE_LIST = [
  'profile',
  'https://www.googleapis.com/auth/drive',
  'https://www.googleapis.com/auth/drive.file'
]
const GAPI_SCOPE = GAPI_SCOPE_LIST.join(' ')
const GAPI_DISCOVERYDOCS = ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"]

const PLAN_LIMIT = 20
const EXPERT_CONSULTATION_LIMIT = 50

firebase.initializeApp(firebaseConfig)
const storeSettings = {
  timestampsInSnapshots: true
}

const SITE_ID = process.env.VUE_APP_SITE_ID
const BACKUP_VERSION = 'v0.0.1'

const USERDATA_COLLECTION_ID = 'user_data'
const PLANS_COLLECTION_ID = 'plans'
const CONFIG_DOCUMENT_ID = SITE_ID

const SHAREDATA_COLLECTION_ID = 'share_data'
const INTERVIEWS_COLLECTION_ID = 'interviews'
const CORRECTIONS_COLLECTION_ID = 'corrections'
const CORRECTION_AMOUNT_JPN = 30000


const FirebaseLib = {
  install: function (Vue, options) {
    Vue.use(planConfig)
    // Vue.use(router)
    const main = new Vue({
      router,
      data: function () {
        return {
          //gapi
          isAuthorizedGapi: false,
          GoogleAuth: {},
          idToken: '',
          //firebase
          db: {},
          functions: {},
          user: {}
        }
      },
      computed: {
        //gapi
        googleUser: function () {
          return this.GoogleAuth.currentUser.get()
        },
        //firebase
        config: function () {
          return firebaseConfig
        },
        authProviderGoogle: function () {
          const provider = new firebase.auth.GoogleAuthProvider()
          return provider
        },
        isAuthenticated: function () {
          if (this.user && this.user.uid) {
            return true
          } else {
            return false
          }
        },
        userDocPath: function () {
          const userDocPath = [USERDATA_COLLECTION_ID, this.user.uid]
          if (this.user && this.user.uid) {
            return userDocPath.join('/')
          }
        },
        shareDocPath: function () {
          const shareDocPath = [SHAREDATA_COLLECTION_ID, this.user.uid]
          if (this.user && this.user.uid) {
            return shareDocPath.join('/')
          }
        },
        plansCollectionPath: function () {
          const plansCollection = [USERDATA_COLLECTION_ID, this.user.uid, PLANS_COLLECTION_ID]
          if (this.user && this.user.uid) {
            return plansCollection.join('/')
          }
        },
        interviewsCollectionPath: function () {
          const interviewsCollection = [SHAREDATA_COLLECTION_ID, this.user.uid, INTERVIEWS_COLLECTION_ID]
          if (this.user && this.user.uid) {
            return interviewsCollection.join('/')
          }
        },
        correctionsCollectionPath: function () {
          const correctionsCollection = [SHAREDATA_COLLECTION_ID, this.user.uid, CORRECTIONS_COLLECTION_ID]
          if (this.user && this.user.uid) {
            return correctionsCollection.join('/')
          }
        },
        correctionDocPath: function (docId) {
          const correctionsCollection = [SHAREDATA_COLLECTION_ID, this.user.uid, CORRECTIONS_COLLECTION_ID, docId]
          if (this.user && this.user.uid) {
            return correctionsCollection.join('/')
          }
        },
        correctionAmountJpn: function () {
          return CORRECTION_AMOUNT_JPN
        }
      },
      methods: {
        //gapi
        handleClientLoad: function () {
          if (!window.gapi) {
            this.$Message.error('ログインに失敗しました　お手数ですがもう一度お試しください')
            return
          }
          window.gapi.load('client:auth2', this.initClient)
        },
        initClient: function () {
          const app = this
          window.gapi.client.init({
            'apiKey': GAPI_APIKEY,
            'clientId': GAPI_CLIENTID,
            'scope': GAPI_SCOPE,
            'discoveryDocs': GAPI_DISCOVERYDOCS
          }).then(function () {
            app.GoogleAuth = window.gapi.auth2.getAuthInstance()
            app.GoogleAuth.isSignedIn.listen(app.updateSigninStatusGapi)
            app.updateSigninStatusGapi(app.GoogleAuth.isSignedIn.get())
          }).catch(err => (console.error(err)))
        },
        signInGapi: function () {
          return this.GoogleAuth.signIn({
            ux_mode: 'redirect',
            prompt: 'select_account'
          })
        },
        signOutGapi: function () {
          const app = this
          this.GoogleAuth.signOut()
            .then(function (response) {
              app.disconnectGapi()
              app.signOut()
            })
            .catch(function (err) {
              console.error("signout err", err)
            })
        },
        disconnectGapi: function () {
          this.GoogleAuth.disconnect()
        },
        updateSigninStatusGapi: function (isSignedIn) {
          if (!isSignedIn) {
            this.isAuthorizedGapi = false
            return
          }
          const app = this
          const gapiUser = this.GoogleAuth.currentUser.get()
          this.isAuthorizedGapi = gapiUser.hasGrantedScopes(GAPI_SCOPE)
          if (this.isAuthorizedGapi) {
            this.idToken = this.googleUser.getAuthResponse().id_token
            if (!this.user) {
              this.signInGoogle()
            }
          }
        },
        getOrCreateDriveFolderId: async function () {
            const folderName = '3kyaku'
            const listQueryList = [
              "name = '" + folderName + "'",
              "and 'root' in parents",
              "and mimeType = 'application/vnd.google-apps.folder'",
              "and trashed = false"
            ]
            const listQuery = listQueryList.join(' ')
            const listResponse = await window.gapi.client.drive.files.list({
              "q": listQuery
            })
            const folderList = listResponse.result.files
            if (folderList.length > 0) {
              return folderList[0].id
            }
            const body = {
              'name': folderName,
              'mimeType': 'application/vnd.google-apps.folder'
            }
            const createResponse = await window.gapi.client.drive.files.create({
              'resource': body
            })
            return createResponse.result.id
          },
          createNewSpreadSheet: async function (spreadSheetKind) {
              if (!this.isAuthorizedGapi) {
                this.$Message.error({
                  content: 'Googleアカウントの認証が切れています。お手数ですがログインし直してください',
                  duration: 5
                })
                this.signOut()
                return Promise.reject(new Error('Gapi user not authorezation'))
              }
              const baseSpreadSheet = this.$planConfig.spreadSheetsIndex[spreadSheetKind]
              const parentFolderId = await this.getOrCreateDriveFolderId()
              const body = {
                'name': baseSpreadSheet.spreadSheetTitle,
                "parents": [
                  parentFolderId
                ]
              }
              const response = await window.gapi.client.drive.files.copy({
                'fileId': baseSpreadSheet.spreadSheetId,
                'resource': body
              })
              return {
                name: response.result.name,
                kind: spreadSheetKind,
                url: 'https://docs.google.com/spreadsheets/d/' + response.result.id,
                createTimestamp: new Date()
              }
            },
            //firebase
            reloadToken: function () {
              const app = this
              return this.user
                .getIdToken(true)
                .then(function (idToken) {
                  app.accessToken = idToken
                })
                .catch(function (err) {
                  console.error(err)
                })
            },
            signInGoogle: function () {
              const app = this
              const credential = firebase.auth.GoogleAuthProvider.credential(
                this.idToken)
              firebase.auth().signInAndRetrieveDataWithCredential(credential)
                .then(function (response) {
                  app.$Message.success('ログインしました')
                  app.$ga.event({
                    eventCategory: 'conversion',
                    eventAction: 'login',
                    eventLabel: 'Googlelogin',
                    eventValue: 0
                  })
                  app.$router.push({ name: 'planList' })
                })
                .catch(function (err) {
                  app.$Message.error('ログインに失敗しました。')
                  app.signOutGapi()
                })
            },
            signOut: function () {
              const app = this
              firebase
                .auth()
                .signOut()
                .then(function () {
                  app.$router.push({ name: 'home' })
                  app.$Message.success('ログアウトしました')
                })
                .catch(function (err) {
                  app.$Message.error('ログアウトに失敗しました')
                  console.error(err)
                })
            },
            setupDb: function () {
              this.db = firebase.firestore()
              this.db.settings(storeSettings)
            },
            setupFunctions: function () {
              this.functions = firebase.functions()
            },
            updateUserDocTimestamp: function () {
              const userDocRef = this.db.doc(this.userDocPath)
              userDocRef.set({
                timestamp: FIREBASE_SERVER_TIMESTAMP
              }, {
                merge: true
              })
            },
            //updateShareDocTimestamp: function () {
            //  const shareDocRef = this.db.doc(this.shareDocPath)
            //  shareDocRef.set({
            //    timestamp: FIREBASE_SERVER_TIMESTAMP
            //  }, {
            //    merge: true
            //  })
            //},
            init: function () {
              this.setupDb()
              this.setupFunctions()
              this.updateUserDocTimestamp()
              //this.updateShareDocTimestamp()
              this.$eventHub.$emit('firebase-initialized', this.user)
            },
            planDocPath: function (planId) {
              const userDocPath = [USERDATA_COLLECTION_ID, this.user.uid]
              const planDocPath = [PLANS_COLLECTION_ID, planId]
              if (this.user && this.user.uid) {
                return userDocPath.concat(planDocPath).join('/')
              }
            },
            getPlans: function () {
              if (!this.isAuthenticated) {
                return
              }
              const app = this
              let query = this.db
                .collection(this.plansCollectionPath)
                .orderBy('updateTimestamp', 'asc')
                .limit(PLAN_LIMIT)
              return query.get()
            },
            createPlan: async function (basicPlanName) {
                if (!this.isAuthenticated) {
                  return
                }
                const app = this
                const plansCollectionRef = this.db.collection(this.plansCollectionPath)
                const plan = this.$planConfig.planIndex[basicPlanName]
                //const defaultSpreadSheet = await this.createNewSpreadSheet('allin')
                const defaultSpreadSheet = await this.createNewSpreadSheet(plan.spreadSheetsKindName)
                const data = {
                  title: '新しい事業計画書',
                  createTimestamp: FIREBASE_SERVER_TIMESTAMP,
                  updateTimestamp: FIREBASE_SERVER_TIMESTAMP,
                  basicPlanUpdateTimestamp: FIREBASE_SERVER_TIMESTAMP,
                  //basicPlan: this.$planConfig.getBasicPlan(basicPlanName),
                  basicPlan: plan.basicPlan,
                  spreadSheets: [
                  defaultSpreadSheet
                ]
                }
                return plansCollectionRef.add(this.$_beforeFirebaseSaving(data))
              },
              getPlan: function (planId) {
                const planDocRef = this.db.doc(this.planDocPath(planId))
                return planDocRef.get()
              },
              updatePlan: function (planId, data) {
                const planDocRef = this.db.doc(this.planDocPath(planId))
                if (data.basicPlan) {
                  data.basicPlanUpdateTimestamp = FIREBASE_SERVER_TIMESTAMP
                }
                data.updateTimestamp = FIREBASE_SERVER_TIMESTAMP
                return planDocRef.set(
                  this.$_beforeFirebaseSaving(data), { merge: true }
                )
              },
              $_beforeFirebaseSaving: function (data) {
                let tempData = {}
                const needsStringifyKeyList = ['basicPlan', 'spreadSheets', 'copiedBasicPlan']
                for (let key in data) {
                  if (needsStringifyKeyList.indexOf(key) !== -1) {
                    tempData[key] = JSON.stringify(data[key])
                  } else {
                    tempData[key] = data[key]
                  }
                }
                return tempData
              },
              deletePlan: function (planId) {
                const planDocRef = this.db.doc(this.planDocPath(planId))
                return planDocRef.delete()
              },
              updateConsultation: function (consultationId, data) {
                const consultationDocPath = [SHAREDATA_COLLECTION_ID, consultationId].join('/')
                const consultationDocRef = this.db.doc(consultationDocPath)
                data.updateTimestamp = FIREBASE_SERVER_TIMESTAMP
                return consultationDocRef.set(
                  this.$_beforeFirebaseSaving(data), { merge: true }
                )
              },
              getConsultations: function () {
                const shareDataCollectionPath = SHAREDATA_COLLECTION_ID
                let query = this.db
                  .collection(shareDataCollectionPath)
                  .where("applicantId", "==", this.user.uid)
                  .orderBy('createTimestamp', 'desc')
                  .limit(PLAN_LIMIT)
                return query.get()
              },
              getConsultationsExpert: function () {
                const shareDataCollectionPath = SHAREDATA_COLLECTION_ID
                let query = this.db
                  .collection(shareDataCollectionPath)
                  .where("expertId", "==", this.user.uid)
                  //.where("applicantId", "==", this.user.uid)
                  .orderBy('createTimestamp', 'desc')
                  .limit(EXPERT_CONSULTATION_LIMIT)
                return query.get()
              },
              getConsultation: function (consultationId) {
                const consultationDocPath = [SHAREDATA_COLLECTION_ID, consultationId].join('/')
                const consultationDocRef = this.db.doc(consultationDocPath)
                return consultationDocRef.get()
              },
              fileRefPath: function (planId, fileName) {
                const shareRefPath = [SHAREDATA_COLLECTION_ID, this.user.uid, 'images', planId]
                if (this.user && this.user.uid) {
                  return shareRefPath.concat([fileName]).join('/')
                }
              },
              uploadFile: function (planId, file) {
                const storageRef = firebase.storage().ref()
                const fileStorageRef = storageRef.child(this.fileRefPath(planId, file.name))
                return fileStorageRef.put(file)
              },
              deleteFile: function (fullPath) {
                const storageRef = firebase.storage().ref()
                const fileStorageRef = storageRef.child(fullPath)
                return fileStorageRef.delete()
              },
              downloadFile: function (fullPath) {
                const storageRef = firebase.storage().ref()
                const fileStorageRef = storageRef.child(fullPath)
                return fileStorageRef.getDownloadURL()
              }
      }
    })
    firebase.auth()
      .getRedirectResult()
      .then(function (result) {
        if (result.credential) {
          /*
          main.showResultMessage(
            'ログインしました：' + result.user.email,
            'success'
          )
          */
        }
      })
      .catch(function (error) {
        console.error(error)
        /*
        main.showResultMessage(
          'ログインに失敗しました：' + error.message,
          'error'
        )
        */
      })
    firebase.auth().onAuthStateChanged(function (user) {
      main.user = user
      if (user) {
        main.init()
      } else {
        ////console.log('no user')
      }
    })
    Vue.prototype.$firebase = main
    main.handleClientLoad()
  }
}
export default FirebaseLib
